import { Box, Text } from '@bechtel/gds';
import React, { FC } from 'react';
import { SummaryStyled } from './styled';
import { CrewChangeSummaryProps } from './types';
import { CrewTree } from '@bechtel/client-common';
import { Trans, t } from '@lingui/macro';

export const CrewChangeSummary: FC<CrewChangeSummaryProps> = ({ sourceCrewMembers, destinationCrewMembers }) => {
  return (
    <Box flexDirection={{ sm: 'column' }} style={{ overflowY: 'hidden' }}>
      <SummaryStyled>
        <Text size="400" color="grey.1000" weight="600" family="graphik">
          <Trans>Summary</Trans>
        </Text>
      </SummaryStyled>

      <Box
        p={{ sm: '500' }}
        alignItems={{ sm: 'flex-start' }}
        style={{ width: '100%', overflowY: 'auto', height: '100vh' }}
        justifyContent={{ sm: 'center' }}
      >
        <CrewTree crewMembers={sourceCrewMembers} showAffectedCrewMembers={true} label={t`Original Crew:`} />
        <CrewTree crewMembers={destinationCrewMembers} showAffectedCrewMembers={false} label={t`Destination Crew:`} />
      </Box>
    </Box>
  );
};
